<template>
  <custom-callout
    ref="callout"
    :has-toggle="canPrint"
    :controlled="true"
    :opened="isOpen"
    class="mt-2 mb-3"
    @click:open="toggle()"
  >
    <template #default>
      <div class="row">
        <div class="col-2">
          <info :title="evaluation.evaluationTypeName">
            <label style="font: normal bold 16px/28px Lato;">
              {{ evaluation.disciplineTypeName }}
            </label>
          </info>
        </div>
        <div class="col ">
          <div class="row ">
            <div
              v-if="!canCoordinate"
              class="col-4 mt-3"
              style="position:relative; margin: 0 auto;"
            >
              <custom-balloon
                class="d-lc-inline"
                :text="evaluation.status"
                background-color="green-light"
              />
            </div>
          </div>
        </div>
        <div class="col-3 pr-4 mt-2 text-right">
          <ActionButton
            v-if="canCoordinate"
            text="Coordinar Cita"
            i="fas fa-calendar-alt fa-fw"
            variant="outline-success"
            class="m-1"
            @click="
              () => {
                isOpen = true;
              }
            "
          />
          <ActionButton
            v-if="canPrint && !canCoordinate"
            text="Imprimir Referido"
            i="fas fa-print fa-fw"
            variant="outline-success"
            class="m-1"
            @click="downloadReferralSheet(evaluation.studentReferralId)"
          />
        </div>
      </div>
    </template>
    <template #edition>
      <article class="info-panel">
        <Coordinate
          v-if="canCoordinate"
          :evaluation="evaluation"
          :student="student"
          @close="
            () => {
              isOpen = false;
            }
          "
          @on-coordination-finished="onCoordinationFinished"
        />
        <appointment-info
          v-if="canPrint"
          :appointment="appointmentInformation"
        />
      </article>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
import Info from './components/Info.vue';
import Coordinate from './components/Coordinate.vue';
import AppointmentInformation from './components/AppointmentInformation.vue';
import referralStatuses from '@/utils/constants/rp/rpStatuses.js';
import { appointmentStatusCodes } from '@/utils/constants/appointment-status/appointmentStatusCodes';
import reportService from '@/services/report';
import appointmentServiceManager from '@/services/api/appointment.api.js';

export default {
  props: {
    evaluation: { type: Object, require: true, default: () => ({}) },
    student: {
      type: Object,
      require: true,
      default: () => ({ studentAge: 0, studentSieId: 0 }),
    },
  },
  components: {
    CustomCallout,
    CustomBalloon,
    ActionButton,
    Info,
    Coordinate,
    AppointmentInfo: AppointmentInformation,
  },
  data() {
    return {
      isOpen: false,
      appointmentInformation: null,
    };
  },
  computed: {
    canCoordinate() {
      return (
        this.evaluation.referralStatusId === referralStatuses.Aprobado &&
        (this.evaluation.appoitmentStatusId === undefined ||
          this.evaluation.appoitmentStatusId === null)
      );
    },
    canPrint() {
      return (
        this.evaluation.referralStatusId === referralStatuses.Cita_Coordinada ||
        (this.evaluation.appoitmentStatusId !== undefined &&
          this.evaluation.appoitmentStatusId ===
            appointmentStatusCodes.coordinated &&
          this.evaluation.referralStatusId === referralStatuses.Aprobado)
      );
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      if (this.canPrint && this.appointmentInformation !== undefined) {
        this.getAppoitmentInformation();
      }
    },
    downloadReferralSheet(studentReferralId) {
      return reportService.downloadReferralReport(studentReferralId);
    },
    async getAppoitmentInformation() {
      const {
        data: response,
      } = await appointmentServiceManager.getAppointmentInformation(
        this.evaluation.studentReferralId
      );
      this.appointmentInformation = response;
    },
    async onCoordinationFinished(status) {
      this.evaluation.referralStatusId = status.referralStatusId;
      this.evaluation.status =
        status.appoitmentStatusName !== undefined
          ? status.referralStatusName + ' - ' + status.appoitmentStatusName
          : status.referralStatusName;
      this.evaluation.appoitmentStatusId = status.appoitmentStatusId;
      this.getAppoitmentInformation();
    },
  },
};
</script>

<style scoped>
.info-panel {
  background: white;
  border: 5px solid #f2f2f2;
  padding: 15px;
}
</style>
